
import { Vue } from "vue-class-component";

export default class PlaneArrival extends Vue {}
